











































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import storage from '@/global/storage'

@Component
export default class SidebarItem extends Vue {
[x: string]: any;
  @Prop() menuItem!: any;
  currentTag: string | undefined = '';
  showLabel: string[] = [];
  get userInfo() {
    return this.$store.state.userInfo;
  }
  private getIsShow() {
    this.showLabel = [];
    if(this.menuType === 'train') {
      const { type, subType } = this.$route.params
      if(subType !== '0') {
        this.showLabel = [`/${type}/0`];
        this.$nextTick(() => {
          (this.$refs.side_menu as any).updateOpened();
        });
      }
    } else {
      const path = this.$route.path;
      const pathArr = path.split('/');
      if (pathArr.length > 3) {
        this.showLabel = [pathArr[2]];
        this.$nextTick(() => {
          (this.$refs.side_menu as any).updateOpened();
        });
      }
    }
  }

  get menuType() {
    if (this.$route.path.startsWith("/train")) {
      return 'train';
    } else if(this.$route.path.startsWith("/mine")) {
      return 'mine';
    } else {
      return 'task';
    }
  }

  trainList: object[] = [
      {
        name: '/1/0',
        meta: {
          label: '新兵营',
          icon: 'iconfont icon-kaifangpingtai'
        }
      },
      {
        name: '/2/0',
        meta: {
          label: '工具培训',
          icon: 'iconfont icon-gongju'
        },
        children: [{
          name: '/2/1',
          meta: {
            label: '2d培训',
          }
        },{
          name: '/2/2',
          meta: {
            label: '点云培训',
          }
        }]
      },
      {
        name: '/3/0',
        meta: {
          label: '进阶培训',
          icon: 'iconfont icon-jinjiecuxiao-xianxing'
        },
        children: [{
          name: '/3/1',
          meta: {
            label: '2d进阶培训',
            icon: ''
          }
        },{
          name: '/3/2',
          meta: {
            label: '点云进阶培训',
            icon: ''
          }
        },{
          name: '/3/3',
          meta: {
            label: '项目培训',
            icon: ''
          }
        }]
      },
      {
        name: '/4/0',
        meta: {
          label: '内部培训',
          icon: 'iconfont icon-huiyiguanli'
        }
      },
      {
        name: '/5/0',
        meta: {
          label: '基地培训',
          icon: 'iconfont icon-fangzidichan'
        }
      },
      {
        name: '/0/0',
        meta: {
          label: '荣誉勋章',
          icon: 'iconfont icon-xunzhang'
        }
      }
  ]
  
  private created() {
    this.selectTag('');
    this.getIsShow();
  }

  @Watch('$route')
  private routechange(to: any, from: any) {
    this.selectTag(from.name);
    this.getIsShow();
  }
  @Watch('menuItem')
  private menuItemChange(val) {
    this.selectTag('');
    this.getIsShow();
  }
  private selectTag(prevName: string) {
    this.$nextTick(() => {
      if (this.$route.path.indexOf('task') > -1) {
        // 当当前路由存在于侧边栏时再切换状态, 刷新时状态消失
        if (Array.isArray(this.menuItem.taskList)) {
          const current = this.$route.path.split('/')[2];
          if (this.menuItem.taskList.map(item => item.name).includes(current)) {
            this.currentTag = current
          }
        }
        // 在任务大厅项目详情页刷新时，tab状态显示问题
        const params = JSON.parse(storage.getSession('lm-project-params'))
        if(this.currentTag === '' && params) {
          this.currentTag = params.name
        }
      } else if (this.$route.path.indexOf('mine') > -1) {
        if (Array.isArray(this.menuItem.mineList)) {
          const current = this.$route.name
          if (this.menuItem.mineList.map(item => item.name).includes(current)) {
            this.currentTag = current
          }
        }
      } else if(this.$route.path.indexOf('train') > -1) {
          const { type, subType } = this.$route.params
          const path = `/${type}/${subType}`
          this.currentTag = path
      }
    });
  }
  handleSelect(path: string) {
    this.$nextTick(()=>{
      if(this.$refs.childrenMenu) {
        (this.$refs.childrenMenu as any).forEach(e => {
          if(!e.active&&!e.accordion){
            e.opened = false;
          }
        });
      }
    });
    if(this.menuType === 'train') {
      this.$router.push(`/train${path}`)
    } else {
      this.$router.push({ name: path });
      this.$eventBus.$emit('menu-state-reset', path);
    }
  }
}
